export const APP_PREV_ROUTE = 'shared/PREV_ROUTE';
export const MUTATE_POP_NAV_HISTORY = 'shared/POP_NAV_HIST';
export const MUTATE_PUSH_NAV_HISTORY = 'shared/PUSH_NAV_HIST';

//App state
export const APP_STATE_LOADING = 'shared/APP_STATE_LOADING';
export const MUTATE_SET_APP_STATE_LOADING = 'shared/MUTATE_SET_APP_STATE_LOADING';

//Routing Module
export const ROUTING_QUERY = 'routing/ROUTING_QUERY';
export const ROUTING_SHOW_OVERLAY = 'routing/SHOW_OVERLAY';
export const ROUTING_TRANSITION_MAIN = 'routing/TRANSITION_MAIN';
export const ROUTING_TRANSITION_OVERLAY = 'routing/TRANSITION_OVERLAY';
export const MUTATE_ROUTE_QUERY = 'routing/ROUTE_QUERY';
export const MUTATE_SET_SHOW_OVERLAY = 'routing/SET_SHOW_OVERLAY';
export const MUTATE_SET_TRANSITION_MAIN = 'routing/SET_TRANSITION_MAIN';
export const MUTATE_SET_TRANSITION_OVERLAY = 'routing/SET_TRANSITION_OVERLAY';
export const ACTION_SET_TRANSITION_MAIN_ASYNC = 'routing/SET_TRANSITION_MAIN_ASYNC';

const accountModule = 'account';
export const GETTER_BIRTHDATE = `${accountModule}/birthdate`;
export const GETTER_EMAIL = `${accountModule}/email`;
export const GETTER_FIRSTNAME = `${accountModule}/firstname`;
export const GETTER_LASTNAME = `${accountModule}/lastname`;
export const GETTER_MIDDLENAME = `${accountModule}/middlename`;
export const GETTER_MOBILENUMBER = `${accountModule}/mobilenumber`;
export const GETTER_TOKENS = `${accountModule}/tokens`;
export const GETTER_ACCOUNT_ID = `${accountModule}/accountId`;
export const GETTER_DOCTORS_BY_ID = `${accountModule}/doctorsById`;
export const GETTER_DOCTORS_BY_USER_TAG = `${accountModule}/doctorsByUserTag`;
export const GETTER_PATIENTS = `${accountModule}/patients`;
export const GETTER_DOCTOR_PATIENT_PARTNER = `${accountModule}/doctorPatientPartner`;
export const GETTER_DOCTOR_PATIENT_PARTNER_BY_TOKEN = `${accountModule}/doctorPatientPartnerByToken`;
export const ACTION_EDIT_ACCOUNT = `${accountModule}/editAccount`;
export const ACTION_REMOVE_TOKEN = `${accountModule}/removeToken`;
export const MUTATE_ACCOUNT = `${accountModule}/mutateAccount`;
export const MUTATE_REMOVE_TOKEN = `${accountModule}/mutateRemoveToken`;

const appointmentsModule = 'appointments';
export const GETTER_LOADED = `${appointmentsModule}/loaded`;
export const MUTATE_LOADED = `${appointmentsModule}/mutateLoaded`;

export const GETTER_NOW_APPOINTMENTS = `${appointmentsModule}/nowAppointments`;
export const GETTER_FUTURE_APPOINTMENTS = `${appointmentsModule}/futureAppointments`;
export const GETTER_DENIED_APPOINTMENTS = `${appointmentsModule}/deniedAppointments`;
export const GETTER_PENDING_APPOINTMENTS = `${appointmentsModule}/pendingAppointments`;
export const GETTER_NEW_REQUEST_APPOINTMENTS = `${appointmentsModule}/newRequestAppointments`;
export const GETTER_ALL_APPOINTMENTS = `${appointmentsModule}/allAppointments`;
export const GETTER_PRIORITY_APPOINTMENTS = `${appointmentsModule}/priorityAppointments`;
export const ACTION_REFRESH_APPOINTMENTS = `${appointmentsModule}/refreshAppointments`;
export const MUTATE_SET_APPOINTMENTS = `${appointmentsModule}/setAppointments`;

//calls
const callsModule = 'calls'
export const GETTER_ACTIVE_SESSIONS = `${callsModule}/activeSessions`;
export const MUTATE_SET_ACTIVE_SESSIONS = `${callsModule}/setActiveSessions`;
export const ACTION_REFRESH_ACTIVE_SESSIONS = `${callsModule}/actionRefreshActiveSessions`;

//invite code
const inviteCodeModule = 'inviteCode';
export const GETTER_INVITE_CODE_URL_TOKEN = `${inviteCodeModule}/getInviteCodeURLToken`;
export const MUTATE_SET_INVITE_CODE_TOKEN = `${inviteCodeModule}/setInviteCodeURLToken`;
export const MUTATE_REMOVE_INVITE_CODE_TOKEN = `${inviteCodeModule}/removeInviteCodeURLToken`;
export const ACTION_SET_INVITE_CODE_TOKEN = `${inviteCodeModule}/actionSetInviteCodeURLToken`;
export const ACTION_REMOVE_INVITE_CODE_TOKEN = `${inviteCodeModule}/actionRemoveInviteCodeURLToken`;
export const INVITE_CODE_TOKEN_QUERY_KEY = 'token';

//clinic qr (NS portal claiming flow)
const clinicQrModule = 'clinicQr';
export const GETTER_CLINIC_QR_DOCTOR_TOKEN = `${clinicQrModule}/doctorToken`;
export const ACTION_SET_CLINIC_QR_DOCTOR_TOKEN = `${clinicQrModule}/setDoctorToken`;
export const ACTION_CLEAR_CLINIC_QR_DOCTOR_TOKEN = `${clinicQrModule}/clearDoctorToken`;
export const MUTATE_CLINIC_QR_DOCTOR_TOKEN = `${clinicQrModule}/mutateDoctorToken`;

//babybook (eligibility whitelist for newborn baby book preview)
const babybookModule = 'babybook';
export const GETTER_BABYBOOK_WHITELIST = `${babybookModule}/whitelistedTokens`;
export const ACTION_FETCH_BABYBOOK_WHITELIST = `${babybookModule}/fetchWhitelistedTokens`;
export const ACTION_CLEAR_BABYBOOK_MODULE = `${babybookModule}/clearBabybookModule`;
export const MUTATE_BABYBOOK_WHITELIST = `${babybookModule}/mutateWhitelistedTokens`;
export const MUTATE_BABYBOOK_FETCHING = `${babybookModule}/mutateFetching`;
export const MUTATE_CLEAR_BABYBOOK_MODULE = `${babybookModule}/mutateClearBabybookModule`;

const medicineModule = 'medicine';
export const GETTER_MEDICINE_ORDERS_LOADING = `${medicineModule}/getMedicineOrdersLoading`;
export const GETTER_MEDICINE_ORDERS = `${medicineModule}/getMedicineOrders`;
export const GETTER_ONGOING_MEDICINE_ORDERS = `${medicineModule}/getOnGoingMedicineOrders`;
export const GETTER_MEDICINE_PARTNERS = `${medicineModule}/getMedicinePartners`;
export const GETTER_MEDICINE_PARTNER = `${medicineModule}/getMedicinePartner`;
export const GETTER_PAST_MEDICINE_ORDERS = `${medicineModule}/getPastMedicineOrders`;
export const GETTER_NEED_ORDER_RELOAD = `${medicineModule}/getNeedsReload`;
export const ACTION_SET_MEDICINE_STATE = `${medicineModule}/setMedicineState`;
export const ACTION_SET_ORDER_LAST_MESSAGE = `${medicineModule}/setOrderLastMessage`;
export const ACTION_CLEAR_MEDICINE_MODULE = `${medicineModule}/clearMedicineModule`;
export const MUTATE_ORDER_LAST_MESSAGE = `${medicineModule}/mutateLastOrderMessage`;
export const MUTATE_MEDICINE_STATE = `${medicineModule}/mutateMedicineState`;
export const MUTATE_CLEAR_MEDICINE_MODULE = `${medicineModule}/mutateClearMedicineModule`;

//pharmacy order module
const pharmacyOrderModule = 'pharmacyOrderModule';
export const ACTION_RESET_PHARMACY_ORDER = `${pharmacyOrderModule}/ACTION_RESET_PHARMACY_ORDER`;
export const ACTION_UPDATE_PHARMACY_ORDER = `${pharmacyOrderModule}/ACTION_UPDATE_PHARMACY_ORDER`;
export const MUTATE_PHARMACY_ORDER = `${pharmacyOrderModule}/MUTATE_PHARMACY_ORDER`;
export const MUTATE_ADD_ATTACHED_ID = `${pharmacyOrderModule}/MUTATE_ADD_ATTACHED_ID_FILE`;
export const MUTATE_ADD_ATTACHED_PRESCRIPTION = `${pharmacyOrderModule}/MUTATE_ADD_ATTACHED_PRESCRIPTION`;
export const MUTATE_ADD_ORDER_DATA_ITEM = `${pharmacyOrderModule}/MUTATE_ADD_ORDER_DATA_ITEM`;
export const MUTATE_REMOVE_ATTACHED_ID = `${pharmacyOrderModule}/MUTATE_REMOVE_ATTACHED_ID_FILE`;
export const MUTATE_REMOVE_ATTACHED_PRESCRIPTION = `${pharmacyOrderModule}/MUTATE_REMOVE_PRESCRIPTION`;
export const MUTATE_REMOVE_ORDER_DATA_ITEM = `${pharmacyOrderModule}/MUTATE_REMOVE_ORDER_DATA_ITEM`;
export const MUTATE_UPDATE_ATTACHED_PRESCRIPTION_REMARKS = `${pharmacyOrderModule}/MUTATE_UPDATE_PRESCRIPTION_REMARKS`;
export const MUTATE_ORDER_ATTACHED_PRESCRIPTION_INCLUDE_OTHER_ITEMS = `${pharmacyOrderModule}/MUTATE_ORDER_ATTACHED_PRESCRIPTION_INCLUDE_OTHER_ITEMS`;
export const MUTATE_UPDATE_ORDER_DATA_ITEM = `${pharmacyOrderModule}/MUTATE_UPDATE_ORDER_DATA_ITEM`;

//watson pharmacy order module
const watsonPharmacyOrderModule = 'watsonPharmacyOrderModule';
export const ACTION_RESET_WATSON_PHARMACY_ORDER = `${watsonPharmacyOrderModule}/ACTION_RESET_ORDER`;
export const ACTION_UPDATE_WATSON_PHARMACY_ORDER = `${watsonPharmacyOrderModule}/ACTION_UPDATE_ORDER`;
export const MUTATE_WATSON_PHARMACY_ORDER = `${watsonPharmacyOrderModule}/MUTATE_ORDER`;
export const GETTER_PRESCRIPTION_HAS_VALID_COUPON = `${watsonPharmacyOrderModule}/GETTER_PRESCRIPTION_HAS_VALID_COUPON`;
export const GETTER_PHARMACY_ORDER_PARTNER = `${watsonPharmacyOrderModule}/GETTER_PHARMACY_ORDER_PARTNER`;
export const GETTER_PHARMACY_ORDER_IS_BLOCKED = `${watsonPharmacyOrderModule}/GETTER_PHARMACY_ORDER_IS_BLOCKED`;
export const GETTER_PHARMACY_ORDER_SUBMISSION_BODY = `${watsonPharmacyOrderModule}/GETTER_PHARMACY_ORDER_SUBMISSION_BODY`;

export const GETTER_GET_WATSONS_BRANCH = 'GETTER_GET_WATSONS';
export const GETTER_GET_WATSON_CITIES = 'GETTER_GET_WATSON_CITIES';
export const ACTION_SET_WATSONS_BRANCH = 'ACTION_SET_WATSONS_BRANCH';
export const ACTION_SET_WATSONS_CITIES = 'ACTION_SET_WATSONS_CITIES';
export const MUTATE_WATSONS_BRANCH = 'MUTATE_WATSONS_BRANCH';
export const MUTATE_WATSONS_CITIES = 'MUTATE_WATSONS_CITIES';

export const ACTION_SET_COUPON = 'ACTION_SET_COUPON';
export const GETTER_GET_COUPON = 'GETTER_GET_COUPON';
export const MUTATE_COUPON = 'MUTATE_COUPON';

export const GETTER_FILES = 'GETTER_FILES';
export const GETTER_FILES_STATE = 'GETTER_FILES_STATE';
export const GETTER_FILES_FETCHING = 'GETTER_FILES_FETCHING';
export const GETTER_FILES_FROM_DOC = 'GETTER_FILES_FROM_DOC';
export const GETTER_FILES_FROM_DOC_PRESCRIPTIONS = 'GETTER_FILES_FROM_DOC_PRESCRIPTION';
export const GETTER_FILES_FROM_DOC_LAB_TESTS = 'GETTER_FILES_FROM_DOC_LAB_TESTS';
export const GETTER_FILES_FROM_DOC_OTHER_NOTES = 'GETTER_FILES_FROM_DOC_OTHER_NOTES';
export const GETTER_FILES_WITH_PROGRAM = 'GETTER_FILES_WITH_PROGRAM';
export const ACTION_SET_FILES_STATE = 'ACTION_SET_FILES_STATE';
export const ACTION_SET_FILE_ORDER_ID = 'ACTION_SET_FILE_ORDER_ID';
export const MUTATE_FILE_ORDER_ID = 'MUTATE_FILE_ORDER_ID';
export const MUTATE_FILES_STATE = 'MUTATE_FILES_STATE';

// bills
export const GETTER_BILLS_STATE = 'GETTER_BILLS_STATE';
export const GETTER_UNSETTLED_BILLS = 'GETTER_UNSETTLED_BILLS';
export const GETTER_SETTLED_BILLS = 'GETTER_SETTLED_BILLS';
export const ACTION_SET_BILLS_STATE = 'ACTION_SET_BILLS_STATE';
export const ACTION_CLEAR_BILLS_MODULE = 'ACTION_CLEAR_BILLS_MODULE';
export const MUTATE_BILLS_STATE = 'MUTATE_BILLS_STATE';
export const MUTATE_CLEAR_BILLS_MODULE = 'MUTATE_CLEAR_BILLS_MODULE';

// messages
export const GETTER_MESSAGES_STATE = 'GETTER_MESSAGES_STATE';
export const ACTION_SET_MESSAGES_STATE = 'ACTION_SET_MESSAGES_STATE';
export const MUTATE_MESSAGES_STATE = 'MUTATE_MESSAGES_STATE';
export const GETTER_DOCTOR_LATEST_MESSAGES = 'GETTER_DOCTOR_LATEST_MESSAGES';
export const GETTER_UNREAD_MESSAGES = 'GETTER_UNREAD_MESSAGES';
export const ACTION_ADD_DOCTOR_LATEST_MESSAGES = 'ACTION_ADD_DOCTOR_LATEST_MESSAGES';
export const ACTION_ADD_UNREAD_MESSAGE_COUNT = 'ACTION_ADD_UNREAD_MESSAGE_COUNT';
export const ACTION_REMOVE_UNREAD_MESSAGE_COUNT = 'ACTION_REMOVE_UNREAD_MESSAGE_COUNT';
export const ACTION_CLEAR_MESSAGE_MODULE = 'ACTION_CLEAR_MESSAGE_MODULE';
export const MUTATE_ADD_DOCTOR_LATEST_MESSAGES = 'MUTATE_ADD_DOCTOR_LATEST_MESSAGES';
export const MUTATE_ADD_UNREAD_MESSAGE_COUNT = 'MUTATE_ADD_UNREAD_MESSAGE_COUNT';
export const MUTATE_REMOVE_UNREAD_MESSAGE_COUNT = 'MUTATE_REMOVE_UNREAD_MESSAGE_COUNT';
export const MUTATE_CLEAR_MESSAGE_MODULE = 'MUTATE_CLEAR_MESSAGE_MODULE';

// toast
export const GETTER_TOAST_STATE = 'GETTER_TOAST_STATE';
export const ACTION_SHOW_TOAST = 'ACTION_SHOW_TOAST';
export const MUTATE_SHOW_TOAST = 'MUTATE_SHOW_TOAST';

//clear modules
export const MUTATE_CLEAR_ACCOUNT_MODULE = `${accountModule}/clearAccount`;
export const ACTION_CLEAR_ACCOUNT_MODULE = `${accountModule}/actionClearAccount`;
export const MUTATE_CLEAR_APPOINTMENTS_MODULE = `${appointmentsModule}/clearAppointments`;
export const ACTION_CLEAR_APPOINTMENTS_MODULE = `${appointmentsModule}/actionClearAppointments`;
export const MUTATE_CLEAR_CALLS_MODULE = `${callsModule}/clearCallsModule`;
export const ACTION_CLEAR_CALLS_MODULE = `${callsModule}/actionClearCallsModule`;


export const GETTER_PROGRAM_QUESTIONS = 'GETTER_PROGRAM_QUESTIONS';
export const GETTER_SUBMIT_PROGRAM_BODY = 'GETTER_SUBMIT_PROGRAM_BODY';
export const GETTER_COUPON_FILEID = 'GETTER_COUPON_FILEID';
export const ACTION_SET_ANSWER = 'ACTION_SET_ANSWER';
export const ACTION_RESET_PROGRAM_STATE = 'ACTION_RESET_PROGRAM_STATE';
export const MUTATE_SET_ANSWER = 'MUTATE_SET_ANSWER';
export const MUTATE_RESET_PROGRAM_STATE = 'MUTATE_RESET_PROGRAM_STATE';

//ondemand
export const GETTER_ONDEMAND_BOOKINGS = 'GETTER_ONDEMAND_BOOKINGS';
export const GETTER_ONDEMAND_LATEST_BOOKING = 'GETTER_ONDEMAND_LATEST_BOOKING';
export const GETTER_SHOW_LATEST_BOOKING_BANNER = 'GETTER_SHOW_LATEST_BOOKING_BANNER';
export const GETTER_ONDEMAND_BOOKING_DETAILS = 'GETTER_ONDEMAND_BOOKING_DETAILS';
export const MUTATE_SET_OD_BOOKING_DETAILS = 'MUTATE_SET_OD_BOOKING_DETAILS';
export const MUTATE_SET_OD_BOOKING_LIST = 'MUTATE_SET_OD_BOOKING_LIST';
export const MUTATE_RESET_OD_BOOKING_DETAILS = 'MUTATE_RESET_OD_BOOKING_DETAILS';
export const MUTATE_HIDDEN_OD_BOOKING_ID = 'MUTATE_HIDDEN_OD_BOOKING_ID';
export const ACTION_SET_OD_BOOKING_DETAILS = 'ACTION_SET_OD_BOOKING_DETAILS'
export const ACTION_GET_OD_BOOKINGS = 'ACTION_GET_OD_BOOKINGS';
export const ACTION_SET_HIDDEN_OD_BOOKING_ID = 'ACTION_SET_HIDDEN_OD_BOOKING_ID';
export const ACTION_RESET_OD_BOOKING_DETAILS = 'ACTION_RESET_OD_BOOKING_DETAILS';
